import api from './axios'; 

const packageRequest = {
    getAllPackage(){
        return api.get('/package')
    },
    savePackage(form){
        return api.post('/package',form)
    },
    updatePackage(id,form){
        return api.patch(`/package/${id}`,form)
    }
}

export default packageRequest;